import { createSlice } from '@reduxjs/toolkit';
import { getClinicByIdApi } from '../../../rtk-apis/clinics/getClinicById';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
};

const getClinicByIdSlice = createSlice({
  name: 'getClinicById',
  initialState,
  reducers: {
    clearState: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(getClinicByIdApi.pending, state => {
        state.loading = true;
        state.status = '';
        state.result = null;
        state.msg = '';
      })
      .addCase(getClinicByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
      })
      .addCase(getClinicByIdApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action.payload as string) || 'Something went wrong!';
      });
  },
});

export default getClinicByIdSlice.reducer;
export const { clearState } = getClinicByIdSlice.actions;
